export const ParsedHTML = ({ htmlString }: { htmlString: string }) => {
  return (
    <div
      className="html-parser"
      dangerouslySetInnerHTML={{ __html: htmlString }}
    />
  );
};
